// extracted by mini-css-extract-plugin
export default {"maincontainer":"EditPortfolio_maincontainer__FOD6L"};